/* Messe-Shop24 – Expressversand-Modal inkl. Adress-Autocomplete (OpenStreetMap)
   Herkunft: sections/main-product.liquid (Canopy 6.3.1 live, Z. 1365–1528), 1:1 übernommen 2026-10-04.
   Eigene Datei: wird von Canopy-Updates nicht überschrieben. */
(function () {
  const modal    = document.getElementById('expressModal');
  const closeBtn = document.getElementById('expressModalClose');
  if (!modal) return;

  /* Datepicker Minimum = morgen */
  const dateInput = document.getElementById('express-lieferdatum');
  if (dateInput) {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    dateInput.min = tomorrow.toISOString().split('T')[0];
  }

  /* Modal öffnen */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.express-shipping-trigger')) return;
    e.preventDefault();
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  });

  /* Modal schließen */
  function closeModal() {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  closeBtn.addEventListener('click', closeModal);
  modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

  /* Erfolgsseite: "Fenster schließen"-Button */
  document.addEventListener('click', function (e) {
    if (e.target && e.target.id === 'expressSuccessClose') closeModal();
  });

  /* Nach Absenden: Erfolgsseite anzeigen und Modal öffnen */
  if (window.location.search.includes('express_sent=true')) {
    // Formular-Bereiche ausblenden
    var formBody = modal.querySelector('.express-modal-body:not(#express-success-body)');
    var formFooter = document.getElementById('express-form-footer');
    if (formBody)   formBody.style.display   = 'none';
    if (formFooter) formFooter.style.display = 'none';
    // Erfolgsseite einblenden
    var successBody = document.getElementById('express-success-body');
    if (successBody) successBody.style.display = '';
    // Modal öffnen
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    history.replaceState(null, '', window.location.pathname);
  }

  /* Accordion: alle Sektionen und Buttons ermitteln */
  var accToggles = modal.querySelectorAll('.express-accordion-toggle');

  function openSection(btn) {
    var content = document.getElementById(btn.dataset.target);
    btn.setAttribute('aria-expanded', 'true');
    content.classList.remove('is-collapsed');
  }
  function closeSection(btn) {
    var content = document.getElementById(btn.dataset.target);
    btn.setAttribute('aria-expanded', 'false');
    content.classList.add('is-collapsed');
  }

  /* Auf Desktop (≥769px) alle Sektionen aufklappen */
  if (window.matchMedia('(min-width: 769px)').matches) {
    accToggles.forEach(openSection);
  }

  /* Accordion Toggle: exklusiv – immer nur eine Sektion offen */
  accToggles.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var isExpanded = this.getAttribute('aria-expanded') === 'true';
      if (isExpanded) {
        /* Aktive Sektion schließen */
        closeSection(this);
      } else {
        /* Alle anderen schließen, diese öffnen */
        accToggles.forEach(closeSection);
        openSection(this);
      }
    });
  });

  /* ===== Adress-Autocomplete via OpenStreetMap (kostenlos, kein API Key) ===== */
  const streetInput = document.getElementById('express-strasse');
  const plzInput    = document.getElementById('express-plz');
  const ortInput    = document.getElementById('express-ort');

  if (!streetInput) return;

  const dropdown = document.createElement('ul');
  dropdown.id = 'express-addr-dropdown';
  dropdown.style.cssText = [
    'position:absolute','z-index:10000','background:#fff',
    'border:1.5px solid #d1d5db','border-radius:8px',
    'box-shadow:0 8px 24px rgba(0,0,0,0.12)','margin:4px 0 0',
    'padding:4px 0','list-style:none','width:100%',
    'max-height:220px','overflow-y:auto','font-size:14px','display:none'
  ].join(';');
  streetInput.parentElement.style.position = 'relative';
  streetInput.parentElement.appendChild(dropdown);

  let debounceTimer;

  streetInput.addEventListener('input', function () {
    clearTimeout(debounceTimer);
    const query = this.value.trim();
    if (query.length < 4) { dropdown.style.display = 'none'; return; }

    debounceTimer = setTimeout(function () {
      fetch(
        'https://nominatim.openstreetmap.org/search'
        + '?format=json&addressdetails=1&limit=6&countrycodes=de'
        + '&q=' + encodeURIComponent(query),
        { headers: { 'Accept-Language': 'de' } }
      )
      .then(function (r) { return r.json(); })
      .then(function (results) {
        dropdown.innerHTML = '';
        if (!results.length) { dropdown.style.display = 'none'; return; }

        results.forEach(function (item) {
          const a          = item.address;
          const strasse    = a.road || '';
          const hausnummer = a.house_number || '';
          const plz        = a.postcode || '';
          const ort        = a.city || a.town || a.village || a.municipality || '';
          if (!strasse || !plz) return;

          const li = document.createElement('li');
          li.style.cssText = 'padding:10px 14px;cursor:pointer;line-height:1.4;border-bottom:1px solid #f3f4f6;';
          li.innerHTML =
            '<span style="font-weight:600;color:#111827">' + strasse + (hausnummer ? ' ' + hausnummer : '') + '</span>' +
            '<span style="color:#6b7280;font-size:13px;display:block">' + plz + ' ' + ort + '</span>';

          li.addEventListener('mouseenter', function () { this.style.background = '#f0f9ff'; });
          li.addEventListener('mouseleave', function () { this.style.background = ''; });
          li.addEventListener('mousedown', function (e) {
            e.preventDefault();
            streetInput.value = strasse + (hausnummer ? ' ' + hausnummer : '');
            plzInput.value    = plz;
            ortInput.value    = ort;
            dropdown.style.display = 'none';
          });

          dropdown.appendChild(li);
        });

        dropdown.style.display = dropdown.children.length ? 'block' : 'none';
      })
      .catch(function () { dropdown.style.display = 'none'; });
    }, 350);
  });

  streetInput.addEventListener('blur', function () {
    setTimeout(function () { dropdown.style.display = 'none'; }, 150);
  });
  streetInput.addEventListener('focus', function () {
    if (dropdown.children.length) dropdown.style.display = 'block';
  });

})();
